<template>
  <section>
    <input
      type="radio"
      @change="onChange"
      :id="uid"
      :value="value"
      :name="radioName"
      :checked="modelValue == value"
      class="appearance-none rounded-full h-4 w-4 border-2 border-linear-strong bg-transparent checked:bg-surface-inverse focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain mr-2 cursor-pointer"
    />
    <label :for="uid" class="font-label text-fg-secondary uppercase text-xs">{{ label }}</label>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RadioInput',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    uid: { type: String, required: true },
    label: { type: String, required: true },
    modelValue: { type: [String, Number], required: true },
    value: { type: [String, Number], required: true },
    radioName: { type: String, required: true },
  },
  emits: {
    'update:modelValue'(evt: string | number) {
      return !!evt
    },
  },
  methods: {
    onChange() {
      this.$emit('update:modelValue', this.value)
    },
  },
})
</script>
